import { createAction, props } from '@ngrx/store';

export enum ConsentUrlActions {
  consentUrlsLoaded = '[ConsentUrls] Set Consent Loaded',
}

export const consentUrlsLoaded = createAction(
  ConsentUrlActions.consentUrlsLoaded,
  props<{
    consentUrlsLoaded;
  }>(),
);
